var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStormActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#fff",
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m18.5436 8.54673c.0813-.26383.1253-.5454.1253-.83784 0-1.4961-1.1501-2.70889-2.5688-2.70889-.7798 0-1.4782.36645-1.9493.94484.5794.41847 1.0661.97033 1.3986 1.63565.1449-.0169.2907-.02538.4371-.02538.9754.00004 1.8681.37335 2.5571.99162zm-10.04455 6.35017h-.96508c-1.39947 0-2.53397-1.1964-2.53397-2.6721 0-1.4758 1.1345-2.67213 2.53397-2.67213 0-1.95451 1.68942-3.53891 3.77333-3.53891 1.4136 0 2.6456.72906 3.292 1.80811-1.337.52936-2.3293 1.80141-2.5246 3.33973-.0377.297.1785.5574.4626.5574.2352 0 .4312-.1809.4625-.4266.2029-1.59441 1.4985-2.75121 2.9866-2.75121 1.6643 0 3.0136 1.42276 3.0136 3.17781 0 1.7551-1.3493 3.1779-3.0136 3.1779h-2.7281l-2.8893 4.1031v-3.3075h-2.41418zm4.75925 0 .4278-.6076h-2.5092v-3.3074l-2.67782 3.915z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormActive);
export default __webpack_public_path__ + "static/media/storm_active.a1d5ef8de55583e376fba2142fc95e1d.svg";
export { ForwardRef as ReactComponent };